module.exports = __webpack_public_path__ + "static/media/header-image-tablet.55fcfeef.jpg";